import { GoogleOAuthProvider } from '@react-oauth/google'

export const GoogleOneTapContext: React.FC<{ children: React.ReactNode }> =
  function GoogleOneTapContext({ children }) {
    return (
      <GoogleOAuthProvider clientId={window.CONFIG.googleClientId}>
        {children}
      </GoogleOAuthProvider>
    )
  }
